import React from 'react';
import ReactDOM from 'react-dom/client';

import './css/tailwind.css';
import './css/index.css';

import App from './App.jsx';
import reportWebVitals from './reportWebVitals';
import { ConfigProvider } from './ConfigProvider';
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from './AuthProvider';

ReactDOM.createRoot(document.querySelector("#root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <ConfigProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ConfigProvider>
    </BrowserRouter>
  </React.StrictMode>
);
reportWebVitals();
